class DOMUtil {
  addCssClassToDOMNode (node, cssClass) {
    return node.classList.add(cssClass)
  }

  removeCSSClass = (cssClass, newCssClass) => {
    let elements = document.getElementsByClassName(cssClass)

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i]
      element.classList.remove(newCssClass)
      element.classList.value =  newCssClass 
    }

    return true
  }

  findDomElementByClassAndProperty = (cssClass, propertyName, propertyValue) => {
    let elements = document.getElementsByClassName(cssClass)
    let node

    for (let i = 0; i < elements.length; i++) {
      let element = elements[i]

      if (element[propertyName] === propertyValue) {
        node = element
      }
    }

    return node
  }
}

export { DOMUtil as default }
